var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 d-flex justify-content-between"},[_c('div',{staticClass:"summary-product-item"},[_vm._v(_vm._s(_vm.product.name))]),(_vm.siteBookingSettingDisplayServicePrices)?_c('div',[_vm._v(_vm._s(_vm.currencySymbol)+_vm._s(_vm.product.amount.toFixed(2).toString()))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }